module.exports = __webpack_public_path__ + "af625865fceef1d879c2e1fa4f3a36a3.mp4";